module.exports = __webpack_public_path__ + "static/media/ifca-white-logo.5bc605ef.png";